import axiosClient from '@/config/api/axios'
import { CONVERSATIONS } from '@/config/api/endpoints'
import { isApiConfigured } from '@/config/api/env'
import { conversationToThread } from './conversationMappers'

export async function updateThreadPinned(id, pinned, options = {}) {
  if (!isApiConfigured()) return null
  const { data } = await axiosClient.patch(
    `${CONVERSATIONS}/${id}`,
    { pinned },
    { signal: options.signal },
  )
  return conversationToThread(data)
}
